import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';

export class CurrencyExchange {
  private _from: string;
  private _pair: string;
  private _rate: number;
  private _symbol: string;
  private _to: string;

  constructor() {
    this._from = "";
    this._pair = "";
    this._rate = 1;
    this._symbol = "$";
    this._to = "";
  }

  fromJson(data: any) {
    this.from = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.from], "");
    this.pair = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.pair], "");
    this.rate = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.rate], 0);
    this.symbol = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.symbol], "");
    this.to = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.to], "");
  }

  clone(data: CurrencyExchange) {
    this.from = data.from;
    this.pair = data.pair;
    this.rate = data.rate;
    this.symbol = data.symbol;
    this.to = data.to;
  }

  get from(): string {
    return this._from;
  }

  set from(value: string) {
    this._from = value;
  }

  get pair(): string {
    return this._pair;
  }

  set pair(value: string) {
    this._pair = value;
  }

  get rate(): number {
    return this._rate;
  }

  set rate(value: number) {
    this._rate = value;
  }

  get symbol(): string {
    return this._symbol;
  }

  set symbol(value: string) {
    this._symbol = value;
  }

  get to(): string {
    return this._to;
  }

  set to(value: string) {
    this._to = value;
  }

  toMap() {
    return {
      "from": this.from,
      "pair": this.pair,
      "rate": this.rate,
      "symbol": this.symbol,
      "to": this.to
    };
  }
}
